import './card-contact.scss';

export default () => {
};
